<template>
    <v-card>
      <v-card-title class="justify-center">
        <h1>{{
          (step === 1 ? 'CADASTRAR REDE DE POSTOS' :
          step === 2 ? 'Insira a capa da rede' :
          step === 3 ? 'Selecione o principal posto da rede':
          'Insira os postos na rede').toUpperCase()
        }}</h1>
      </v-card-title>
      <v-divider v-if="!alerta"></v-divider>
      <v-alert
            :value="true"
            type="error"
            style="font-size: 1.2em; width: 100%;"
            class="pa-2"
            v-if="alerta"
        >
              Usuário não encontrado
        </v-alert>
      <v-card-text>
        <v-stepper v-model="step" style="box-shadow: none;">
            <v-stepper-items>
                <v-stepper-content class="pa-0" step="1">
                    <v-layout column class="pa-4">
                        <v-flex align-self-center>
                            <img v-if="imagem && mostrar" :src="imagem" alt="Logo da rede">
                            <v-card elevation="4" height="300" width="300" v-if="!imagem && !croppingLogo">
                                <v-layout justify-center align-center fill-height>
                                    <div class="title white--text pa-4 text-xs-center">
                                      <v-icon size="150">hide_image</v-icon>
                                    </div>
                                </v-layout>
                            </v-card>
                            <v-layout justify-center align-center fill-height v-if="!imagem">
                                    <v-flex xs12 v-show="croppingLogo">
                                        <vue-croppie
                                        ref="croppieRef"
                                        :enableExif="true"
                                        :enforceBoundary="true"
                                        :enableResize="false"
                                        :enableOrientation="false"
                                        :mouseWheelZoom="true"
                                        :showZoomer="false"
                                        :boundary="{ width: 250, height: 250 }"
                                        :viewport="{ width: 200, height: 200, type : 'circle' }"
                                        ></vue-croppie>
                                        <v-btn
                                        flat
                                        @click="recortarLogo"
                                        color="grey darken-2"
                                        block
                                        class="mt-3"
                                        >Recortar imagem</v-btn>
                                    </v-flex>
                            </v-layout>
                            <v-btn class="mt-3" block color="info" @click="$refs.logoInput.click()" v-if="mostrar">
                                Inserir imagem
                                <input
                                    type="file"
                                    style="display:none"
                                    accept="image/*"
                                    ref="logoInput"
                                    @input="carregarLogo"
                                />
                            </v-btn>
                        </v-flex>
                        <v-text-field class="mt-3" outline label="Nome da rede" v-model="nome_rede"/>
                        <v-select
                          class="mb-4"
                          :items="[
                            { text: 'Padrão', value: 0 },
                            { text: 'Sindicato', value: 1 },
                          ]"
                          outline
                          label="Tipo da Rede"
                          v-model="tipo_rede"
                        />
                        <v-tabs
                          v-model="tabs"
                          grow
                          color="transparent"
                          slider-color="info"
                        >
                          <v-tab>Por ID</v-tab>
                          <v-tab>Por CPF</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabs">
                          <v-tab-item lazy>
                            <v-text-field
                                v-if="tabs == 0"
                                v-model="id_pessoa"
                                :loading="loading"
                                box
                                outline
                                color="info"
                                label="Digite o ID do representante"
                            />
                          </v-tab-item>
                          <v-tab-item lazy>
                            <v-text-field
                                v-if="tabs == 1"
                                v-model="cpf"
                                :loading="loading"
                                box
                                outline
                                color="info"
                                label="Digite o CPF do representante"
                                mask="###.###.###-##"
                            />
                          </v-tab-item>
                        </v-tabs-items>
                        <h3
                          class="text-xs-center success--text"
                          v-if="pessoa"
                        >
                          Nome:
                          <b>{{ pessoa.nome }}</b>
                      </h3>
                    </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="2">
                  <v-layout column class="pa-4">
                    <v-flex align-self-center>
                      <img v-if="capa && mostrar2" :src="capa" alt="Capa da rede" width="500">
                      <v-card elevation="4" height="250" width="500" v-if="!capa && !croppingCapa">
                          <v-layout justify-center align-center fill-height>
                            <div class="title white--text pa-4 text-xs-center">
                              <v-icon size="150">hide_image</v-icon>
                            </div>
                          </v-layout>
                      </v-card>
                      <v-layout justify-center align-center fill-height v-if="!capa">
                        <v-flex xs12 v-show="croppingCapa">
                            <vue-croppie
                            ref="croppieCapaRef"
                            :enableExif="true"
                            :enforceBoundary="true"
                            :enableResize="false"
                            :enableOrientation="false"
                            :mouseWheelZoom="true"
                            :showZoomer="false"
                            :boundary="{ width: 500, height: 250 }"
                            :viewport="{ width: 350, height: 200}"
                            ></vue-croppie>
                            <v-btn
                            flat
                            @click="recortarCapa"
                            color="grey darken-2"
                            block
                            class="mt-3"
                            >Recortar imagem</v-btn>
                        </v-flex>
                      </v-layout>
                      <v-btn class="mt-3" block color="info" @click="$refs.capaInput.click()" v-if="mostrar2">
                          Inserir imagem
                          <input
                              type="file"
                              style="display:none"
                              accept="image/*"
                              ref="capaInput"
                              @input="carregarImagem"
                          />
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="3">
                  <v-layout row wrap justify-center class="pa-2">
                    <v-flex xs12>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                          <v-list-tile v-for="(posto, index) in postosSemRede" :key="index" ripple @click="inserirPostoMatriz(posto)">
                              <v-list-tile-avatar>
                                  <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="postosSemRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content class="pa-0" step="4">
                    <v-layout row wrap justify-space-between class="pa-2">
                        <v-flex xs6>
                            <h4 class="text-xs-center">Postos sem rede</h4>
                            <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                                <v-list-tile v-for="(posto, index) in postosSemRede" :key="index" ripple @click="inserirEmRede(posto, index)">
                                    <v-list-tile-avatar>
                                        <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                        <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                        <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="postosSemRede.length === 0">
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-flex xs6>
                            <h4 class="text-xs-center">Postos da rede</h4>
                            <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                                <v-list-tile v-for="(posto, index) in postosDaRede" :key="index" ripple @click="removerDaRede(posto, index)">
                                    <v-list-tile-avatar>
                                        <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                        <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                        <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="postosDaRede.length === 0">
                                    <v-list-tile-content>
                                        <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions class="justify-space-around ma-0 pa-0">
        <v-btn
          block
          large
          color="info"
          :disabled="disabled"
          @click="btnCadastrar"
        >
          <v-icon class="mr-1">save</v-icon>
          Salvar
      </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['rede_posto'],
  data () {
    return {
      step: 1,
      nome_rede: '',
      tipo_rede: 0,
      tabs: 0,
      cpf: undefined,
      id_pessoa: undefined,
      pessoa: undefined,
      postosSemRede: [],
      postosDaRede: [],
      alerta: false,
      croppingLogo: false,
      croppingCapa: false,
      mostrar: true,
      mostrar2: true,
      imagem: null,
      rede: null,
      matriz: null,
      capa: null
    }
  },
  watch: {
    id_pessoa (val) {
      if (val) {
        if (val) this.pegarPessoaPorId(false)
      } else {
        this.pessoa = undefined
      }
    },
    cpf (val) {
      if (val && val.length === 11) {
        this.pegarPessoaPorId(true)
      } else {
        this.pessoa = undefined
      }
    },
    step (val) {
      if (val === 3) this.pegarPostoSemRede()
    }
  },
  methods: {
    carregarLogo (event) {
      this.imagem = null
      this.mostrar = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingLogo = true
          this.$refs.croppieRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    carregarImagem (event) {
      this.capa = null
      this.mostrar2 = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingCapa = true
          this.$refs.croppieCapaRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieCapaRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    recortarLogo () {
      this.mostrar = true
      let options = {
        type: 'base64',
        format: 'png',
        circle: true
      }
      this.$refs.croppieRef.result(options, output => {
        this.imagem = output
        this.croppingLogo = false
      })
    },
    recortarCapa () {
      this.mostrar2 = true
      let options = {
        type: 'base64',
        format: 'png'
      }
      this.$refs.croppieCapaRef.result(options, output => {
        this.capa = output
        this.croppingCapa = false
      })
    },
    cadastrarRede () {
      this.$store.dispatch('cadastrarRede', {
        nome: this.nome_rede,
        tipo_rede: this.tipo_rede,
        is_admin: true,
        id_pessoa: this.id_pessoa ? this.id_pessoa : null,
        cpf: this.cpf ? this.cpf : null
      }).then(rede => {
        this.rede = rede
        if (this.imagem) {
              this.$store.dispatch('inserirArquivoFirebase', {
                arquivo: this.imagem,
                rota: 'redes',
                id: rede.id_rede,
                local: 'logos',
                tipo: 'png'
              }).then(downloadUrl => {
                this.$store.dispatch('atualizarTudoRede', {
                  url_logo: downloadUrl,
                  id_rede: rede.id_rede
                })
              }).then(() => {
                this.step++
              })
            } else this.step++
      })
    },
    pegarPostoSemRede () {
      const data = {
        is_admin: true,
        tipo_rede: this.tipo_rede
      }

      if (this.id_pessoa && this.tipo_rede === 0) {
        data.id_pessoa = this.id_pessoa
      } else if (this.cpf && this.tipo_rede === 0) {
        data.cpf = this.cpf
      }

      this.$store.dispatch('postosSemRede', data).then(value => {
        this.postosSemRede = value.slice()
      })
    },
    pegarPostoDaRede (id) {
      this.$store.dispatch('pegarPostosPorRede', { id }).then(value => {
        this.postosDaRede = value.slice()
      })
    },
    inserirEmRede (posto, index) {
      this.postosDaRede.push(posto)
      this.postosSemRede.splice(index, 1)
    },
    removerDaRede (posto, index) {
      this.postosSemRede.push(posto)
      this.postosDaRede.splice(index, 1)
    },
    inserirPostoMatriz (posto) {
      this.$store.dispatch('inserirPostoMatriz', {
        id: this.rede.id_rede,
        cnpj: posto.cnpj,
        is_admin: true
      }).then(() => {
        this.matriz = posto
        this.postosDaRede.push(posto)
        this.$emit('success', 'Posto pricipal selecionado. Agora insirar os postos pertencentes a rede.')
        this.pegarPostoSemRede()
        this.step++
      })
    },
    btnCadastrar () {
      switch (this.step) {
        case 1:
          this.cadastrarRede()
          break
        case 2:
          if (this.capa) {
            this.$store.dispatch('inserirArquivoFirebase', {
              arquivo: this.capa,
              rota: 'redes',
              id: this.rede.id_rede,
              local: 'logos',
              tipo: 'png'
            }).then(downloadUrl => {
              this.$store.dispatch('atualizarTudoRede', {
                capa: downloadUrl,
                id_rede: this.rede.id_rede
              })
            }).then(() => {
              this.step++
            })
          } else {
            this.step++
          }
          break
        case 3:
          alert('Clique em um posto')
          break
        case 4:
          if (this.postosDaRede.length < 2 && this.rede.is_white_label) {
            alert('Quantidade de postos é insuficientes.')
            return
          }
          this.$store.dispatch('inserirEmRede', {
            lista: this.postosDaRede.map(posto => posto.cnpj),
            id_rede: this.rede.id_rede
          }).then(() => {
            this.$store.dispatch('pegarRedes')
            this.$emit('success', 'Rede cadastrada com sucesso.')
            this.$emit('fechar')
          })
      }
    },
    pegarPessoaPorId (isCPF) {
      const data = {
        is_admin: true
      }

      if (isCPF) data.cpf = this.cpf
      else data.id_pessoa = this.id_pessoa

      this.$store.dispatch('pegarPessoaPorId', data).then(json => {
        this.alerta = false
        this.pessoa = json
      }).catch(() => {
        this.alerta = true
        this.pessoa = undefined
      })
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    disabled () {
      if (this.step === 1 && (!this.pessoa || !this.nome_rede)) return true
      return false
    }
  },
  mounted () {
    if (this.rede_posto) {
      this.pegarPostoDaRede(this.rede_posto.id_rede)
    }
  }
}
</script>
